import { CLOUDINARY_IMAGE_OPTIMIZATION, CLOUDINARY_HOST } from '../../../shared/lib/constants';
import { PAGE_NAME } from '../../../shared/constants';

const APP_NAME = PAGE_NAME.INTEGRATION_LANDING_PAGE;

const FAQ_CONTENT = [
    {
        defaultExpanded: false,
        question: 'How does the Logo Maker work?',
        answer: 'We’ll ask you a few questions about your business and style preferences. Then we’ll put to work our powerful AI technology to create logo designs that best fit your brand, based on a wide selection of hand-made designs.',
    },
    {
        defaultExpanded: false,
        question: 'How long does it take to create my logo?',
        answer: 'Just a few moments! Our technology reduces the complex process of designing a logo for your business into a matter of seconds.',
    },
    {
        defaultExpanded: false,
        question: 'What do you mean by “logos made by talented designers on Fiverr”?',
        answer: 'All of the logo designs we suggest are based on the beautiful work of top designers on Fiverr, adjusted to your needs with the power of Artificial Intelligence (AI).',
    },
    {
        defaultExpanded: false,
        question: 'Can I use the Logo Maker for free?',
        answer: 'You can use the Logo Maker to create a logo and customize it at no cost. Once you have a logo you love, you can buy it by selecting one of our branding packages (starting from US$30) and instantly download the logo in any format you need.',
    },
    {
        defaultExpanded: false,
        question: 'What’s included in the logo branding packages? ',
        answer: 'You’ll get your logo in different formats, sizes, and colors that work across all your digital assets. You can also get a social media kit and brand guidelines - depending on your business needs. See our logo branding packages.',
    },
    {
        defaultExpanded: false,
        question: 'I need help from a professional designer to customize my logo. What can I do?',
        answer: 'You can order customization services from the designer of your logo after buying the logo.',
    },
    {
        defaultExpanded: false,
        question: 'Where can I use my logo?',
        answer: 'Anywhere you want! You’ll get full commercial and non-commercial rights to use your logo anywhere you want to promote your business or brand.',
    },
];

const TEASER_CONTENT = [
    {
        id: 1,
        class: 'add-logo',
    },
    {
        id: 2,
        class: 'create-variations',
    },
    {
        id: 3,
        class: 'ai-working',
    },
];

const GET_INSPIRED_CONTENT = [
    {
        id: 1,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009325990/tropical%20travels.png`,
        designer: 'eladnaider',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/20f8fa5290eb354ca078962118333937-1526295640167/1efad584-cf5f-4497-b310-a457d5b09cd9.jpg`,
    },
    {
        id: 2,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009326000/Foxit.png`,
        designer: 'asafdantes',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/253f2f3246f2733a3993d25b5a016ca6-1520927143570/7b839b9b-4095-493d-a42e-b36a497ace85.jpg`,
    },
    {
        id: 3,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009325982/Brookside%20Realtors.png`,
        designer: 'Obus88',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/6dd5313299be8c2bf90637e6c70f3e27-1591363522960/c869eaed-09f9-4efd-892c-6d186d91841b.jpg`,
    },
    {
        id: 4,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009325986/Motion%20Monkey.png`,
        designer: 'luism03',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/7430d3f11c372d8fcae51674276bfa51-1503422143339/9ea8d44f-b3d4-41c4-ac8b-cd4038d95adc.jpg`,
    },
    {
        id: 5,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009325998/First%20Brew.png`,
        designer: 'eladcohen111',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/6ae381877ebd9934a3a63575e284fd3a-1528186936631/c8f02ec8-9bec-4547-b43b-bdce6a755bfa.jpg`,
    },
    {
        id: 6,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009326004/Happy%20Plants.png`,
        designer: 'amitmaman',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/0b39692dc728aaaf5ebbcb88df0321b2-1567496541365/2ed70b88-b4ce-447a-b089-a1917ec24648.jpg`,
    },
    {
        id: 7,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009325987/Upchow.png`,
        designer: 'xushxush',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/168cc96afca6e0b1802a026d9db638b1-1547023219435/d7668258-c165-4b3b-83e0-dac9b4db26a2.png`,
    },
    {
        id: 8,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009325982/Hydrosource.png`,
        designer: 'zlannan',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/2fc7741a6c85e53bbd3c3387871e8933-661716161564703590195/JPEG_20190802_092308_1136166491728258158.jpg`,
    },
    {
        id: 9,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009326001/Happy%20Plants%20(1).png`,
        designer: 'sasaelebea',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/fc5b7329e86bd9f657c8836c212e9867-1564674190526/ce27b1c4-6909-4dab-b588-5e18fbc59c56.png`,
    },
    {
        id: 10,
        image: `${CLOUDINARY_HOST}/w_280,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/generic_asset/asset/f7d61bd27b87eb26cc5a1730decf65fa-1577009326004/Leaf%20Sweets.png`,
        designer: 'shiranromano',
        designerProfileImage: `${CLOUDINARY_HOST}/t_profile_small,${CLOUDINARY_IMAGE_OPTIMIZATION}/attachments/profile/photo/baff2b5ce15da107cbe0529d54d42c2d-1535643613098/14910336_10153898039721791_8404081264337363555_n.jpg`,
    },
];

const BLOG_POSTS_CONTENT = [
    {
        id: 1,
        image: '73aef6204d61ae137d9e012033fd77ca-1577004296441/Perfect-business.jpg',
        title: 'How to choose the perfect logo for your business',
        excerpt:
            'You’ve done the hard work of fleshing out ideas for your new business. Now, what comes may feel like an even harder ordeal - choosing your brand’s logo...',
        link: 'https://blog.fiverr.com/choosing-the-perfect-logo-for-your-business/',
    },
    {
        id: 2,
        image: '73aef6204d61ae137d9e012033fd77ca-1577004296431/28-fonts.jpg',
        title: 'What these 28 fonts say about your business',
        excerpt:
            'There is an overabundance of factors that need attention at the infancy of your business. What name will I choose? What should my website look like?...',
        link: 'https://blog.fiverr.com/what-these-28-fonts-say-about-your-business/',
    },
    {
        id: 3,
        image: '9d2974ddab6e3fa5a5055ad25e823682-1580906438988/Right-color.jpg',
        title: 'Choosing the right color for your brand',
        excerpt:
            'Colors have their own personalities. In fact, their physiological influence is so powerful that they subconsciously influence the way we all shop, eat...',
        link: 'https://blog.fiverr.com/choosing-the-right-color-for-your-brand-a-complete-guide/',
    },
    {
        id: 4,
        image: '73aef6204d61ae137d9e012033fd77ca-1577004296427/Seven-types.jpg',
        title: 'The seven types of logos and when to use them',
        excerpt:
            'You’ve done it. You created a winning business idea, scribbled out exhaustive blueprints, and are beginning to build the house so you can finally open...',
        link: 'https://blog.fiverr.com/the-seven-types-of-logos-and-when-to-use-them/',
    },
];

const INNER_CLASSES = 'makers-faq inner max-width-container';
const SCROLL_OPTIONS = { behavior: 'smooth', block: 'start' };
const FIRST_SECTION_SELECTOR = '.landing-teaser';

export {
    APP_NAME,
    FAQ_CONTENT,
    TEASER_CONTENT,
    GET_INSPIRED_CONTENT,
    BLOG_POSTS_CONTENT,
    INNER_CLASSES,
    SCROLL_OPTIONS,
    FIRST_SECTION_SELECTOR,
};
